'use client'

interface HamburgerButtonProps {
  onClick?: () => void
  isOpen?: boolean
  showBadge?: boolean
}

export default function HamburgerButton({
  onClick,
  isOpen = false,
  showBadge = false,
}: HamburgerButtonProps) {
  return (
    <button
      onClick={onClick}
      className="p-2 rounded-lg text-foreground hover:bg-muted hover:text-primary transition-colors duration-150 relative w-9 h-9 flex items-center justify-center touch-manipulation active:bg-muted/80 cursor-pointer"
      aria-label={isOpen ? 'Close menu' : 'Open menu'}
    >
      {/* Notification badge - hide when menu is open */}
      {showBadge && !isOpen && (
        <span className="absolute top-1 right-1 w-2 h-2 bg-destructive rounded-full" />
      )}

      <div className="w-5 h-5 flex flex-col justify-center items-center">
        {/* Top line */}
        <span
          className={`w-5 h-0.5 bg-current transition-all duration-300 ease-in-out ${
            isOpen
              ? 'rotate-45 translate-y-[0.375rem]'
              : 'rotate-0 translate-y-0'
          }`}
        />
        {/* Middle line */}
        <span
          className={`w-5 h-0.5 bg-current my-1 transition-all duration-300 ease-in-out ${
            isOpen ? 'opacity-0' : 'opacity-100'
          }`}
        />
        {/* Bottom line */}
        <span
          className={`w-5 h-0.5 bg-current transition-all duration-300 ease-in-out ${
            isOpen
              ? '-rotate-45 -translate-y-[0.375rem]'
              : 'rotate-0 translate-y-0'
          }`}
        />
      </div>
    </button>
  )
}
